module.exports = __webpack_public_path__ + "img/OurServiceBank_pic2.3190d93b.png";